export default "__VITE_ASSET__BMeKKmlR__"